import React from 'react';
import cx from 'classnames';
import InfiniteScroll from 'react-infinite-scroller';
import dateformat from 'dateformat';
import BackButton from '../../../components/BackButton'
import { Row, Col } from 'react-bootstrap';
import styles from "./emailTemplateView.module.scss";
import CommonStyles from '../Styles.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
import SwitchButton from 'src/components/switchButton';
import { NavLink } from 'react-router-dom';
import Text from 'src/components/text';
import Truncate from 'src/components/truncate';
import Tooltip from 'src/components/tooltip';

const EmailTemplateEmptyMessage = '/images/emailTemplateEmptyMessage.svg';
class EmailTemplateView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      hasMore: this.props.hasMore,
      selectedTemplate: null,
      isCreate: false,
    }

    this.onResetClick = this.onResetClick.bind(this);
    this._handleTemplateClick = this._handleTemplateClick.bind(this);
    this._handleCreateTemplateClick = this._handleCreateTemplateClick.bind(this);
    this.handleAssignSelectedTemplate = this.handleAssignSelectedTemplate.bind(this);
    this.onToggleChange = this.onToggleChange.bind(this);
    this._handleEmptyMsgActionClick = this._handleEmptyMsgActionClick.bind(this);
    this._handleClearClick = this._handleClearClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedEmailTemplates = this.localizatedSettings.templates.email;
  }

  onResetClick() {
    this.props.showSettingsSideMenu();
  }

  _handleTemplateClick(emailTemplate){
    this.setState({
      selectedTemplate: emailTemplate,
      isCreate: false
    });

    this.props.hideSettingsSideMenu();
    this.props.fetchEmailTemplate(emailTemplate.id);
  }

  onToggleChange(id,value) {
    let emailTemplate = {
      personal : value
    }
    this.props.updateEmailTemplate(id,emailTemplate);
  }

  _handleCreateTemplateClick(){
    this.props.navigate("/settings/email-template/new");
  }

  handleAssignSelectedTemplate(value){
    this.setState({
      isCreate : false,
      selectedTemplate: value
    })
  }

  componentWillUnmount() {
    this.onResetClick();
  }

  componentDidMount(){
    this.props.fetchEmailTemplates(this.state.query, 0);
  }

  loadMoreItems(page){
    if(this.props.loadMore){
      this.props.loadMore(page);
    }
    this.props.fetchEmailTemplates(this.state.query, page);
  }

  componentWillReceiveProps(nextProps){
    if(this.props.hasMore != nextProps.hasMore){
      this.setState({
        hasMore: nextProps.hasMore
      });
    }
  }

  _handleSearch(e) {
    this.props.invalidateEmailTemplates();
    this.setState({
        query: e.target.value,
        selectedTemplate: null
    })
    this.props.fetchEmailTemplates(e.target.value, 0);
  }

  enabledPersonal(personal){
    let enablePersonal = personal ? false: true;
    
    return enablePersonal;
  }

  _handleEmptyMsgActionClick(){
    this._handleCreateTemplateClick();
  }

  _handleClearClick(){
    this.setState({
      query : ""
    }, () => {
      this.props.invalidateEmailTemplates();
      this.props.fetchEmailTemplates("", 0);
    })
  }

  render() {
    return( 
      <div className={styles.content}>
         <div className={cx(CommonStyles.selectionView)}>
          <div className={styles.innerContent}>
            {!this.props.showSettingsMenu &&
              <BackButton
                  className={CommonStyles.back}
                  title={this.localizedCommonActions.back}
                  onClick={() => this.props.showSettingsSideMenu()}>
              </BackButton>
            }
            <div className={styles.title}>
            <div className = {cx(styles.titleText)}>
              {this.localizedEmailTemplates.title}
            </div>
            </div>
            <div className={cx(styles.section)}>
              <div className={cx(styles.inputField, styles.searchField)}>
                <label>
                  <i className="paperflite-search"></i>
                  <input type="text" 
                    value={this.state.query} 
                    placeholder={this.localizedEmailTemplates.placeholder.template}
                    onChange={this._handleSearch.bind(this)} />
                </label>
                {this.state.query.length > 0 && (<i className={cx('paperflite-close', styles.closeIcon)} onClick={() => this._handleClearClick()}></i>)}
              </div>
              {this.props.showSettingsMenu && 
                <div onClick={() => this._handleCreateTemplateClick() } className={styles.createTemplate}>
                  <div className={styles.heading}>
                      <i className="paperflite-add" aria-hidden="true" /> 
                      <div className={styles.createTemplateText}>{this.localizedEmailTemplates.create_new_template}</div>
                  </div>
                </div> 
              }
              {!this.props.loading && this.props.emailTemplates.length > 0 && 
                <div className={styles.header}>
                  <Col sm={this.props.showSettingsMenu ? 5: 7}>
                      <div>{this.localizedEmailTemplates.headers.template_name}</div>
                  </Col>

                  <Col sm={this.props.showSettingsMenu ? 3 : 5}>
                      <div>{this.localizedEmailTemplates.headers.owner}</div>
                  </Col>
              
                  <Col sm={2} className={styles.templatesHeading}>
                      <div>{this.localizedEmailTemplates.headers.last_updated}</div>
                  </Col>

                  <Col sm={2} className={styles.templatesHeading}>
                      <div>{this.localizedEmailTemplates.headers.mark_as_public}</div>
                  </Col>
                  
                </div>
              }  
            </div> 
            {this.props.emailTemplates.length > 0 &&
              <div className={styles.list}>
                {this._renderEmailTemplates()}
              </div>
            }
            {  this.props.loading && this.props.emailTemplates.length == 0 &&
              <div className={styles.loading}>{this.localizedCommonLoading.loading}...</div>
            }
            
            {!this.props.loading && this.props.emailTemplates.length == 0 && 
              this._renderEmptyMessage()
            }
          </div>   
      </div>
    </div>      
  );
  }

  _renderEmailTemplates(){
    var rows = Array();
    this.props.emailTemplates.forEach((emailTemplate, index) => {
      
      var id = emailTemplate.id;
      let activated = this.enabledPersonal(emailTemplate.personal);

      rows.push(
        <Row className={cx(styles.templateRow, {
            [styles.seletedRow]: this.state.selectedTemplate && emailTemplate.id === this.state.selectedTemplate.id
          })} key = {id}>
          <Col sm={12} className={styles.templateColumn}>
            <NavLink to={`/settings/email-template/${emailTemplate.id}`} className={styles.link}key={emailTemplate.id}>
              <Col sm={this.props.showSettingsMenu ? 5: 7} className={styles.cell}>
                <div className={styles.templateNameWrapper}>
                <Tooltip content={emailTemplate.name}>
                  <span>
                  <Truncate width={emailTemplate.default ? 170 : 170 } >     
                    {emailTemplate.name}
                  </Truncate>
                  </span>
                </Tooltip>
                {emailTemplate.default && <span className = {styles.default}>({this.localizedEmailTemplates.default})</span>}
                </div>
              </Col>
              <Col sm={this.props.showSettingsMenu ? 3 : 5} className={styles.cell}>
              <Text lines={1} text={this._renderName(emailTemplate.createdBy)} />
               
              </Col>
              {this.props.showSettingsMenu && 
                <Col sm={2} className={cx(styles.cell, styles.cellData)}>
                  <div classname={styles.modifiedDate}>{dateformat(emailTemplate.modifiedDate, 'dd mmm yyyy')}</div>
                </Col>
              }
              </NavLink> 
              {this.props.showSettingsMenu && 
                <Col sm={2} className={cx(styles.cell, styles.cellData, styles.switchData)}>
                  <div className = {styles.switchButton}>
                    <SwitchButton
                      id={`makePublic-${id}`}
                      handleCheck={() => this.onToggleChange(id, activated)} 
                      checked={activated} />
                  </div>
                </Col>
              }
          </Col>
        </Row>
      );
    });

    return ( 
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.state.hasMore}
        loadMore={(page) => {this.loadMoreItems(page)}}
        useWindow = {false}
        threshold = {250}
      >
        {rows} 
      </InfiniteScroll>    
    );
  }

  _renderName(owner){
    return `${owner.firstName || ''} ${owner.lastName || ''}`
  }

  _renderEmptyMessage() {
    return (
      <div className={styles.emptyMessage}>
        <Col md={7}>
          <img src={EmailTemplateEmptyMessage} />
        </Col>
        <Col md={5}>
          <div className={styles.message}>
            <h2>{this.localizedEmailTemplates.empty_message.message}!</h2>
            <button onClick={this._handleEmptyMsgActionClick}>{this.localizedEmailTemplates.empty_message.action.create_new}</button>
          </div>
        </Col>  
      </div>
    );
  }
}

export default EmailTemplateView;    